import { render, staticRenderFns } from "./TaskBarcodeReader.component.vue?vue&type=template&id=104b3756&"
import script from "./TaskBarcodeReader.component.vue?vue&type=script&lang=js&"
export * from "./TaskBarcodeReader.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskBarcodeReader.component.vue?vue&type=style&index=0&id=104b3756&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VExpandTransition,VTextField,VTextarea})
